export const GET_CURRENT_ACADID = "GET_CURRENT_ACADID"
export const GET_CURRENT_ACADID_SUCCESS = "GET_CURRENT_ACADID_SUCCESS"
export const GET_CURRENT_ACADID_FAILED = "GET_CURRENT_ACADID_FAILED"

